import React, { Component } from 'react';
import { providerIntents } from '../consts.js';
import ProviderIntent from '../components/ProviderIntent.js';
import cartApi from '../../cartApi.js';
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import { storePubSub } from '../consts.js';
import mobileViewTypes from 'wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes';
import WixStoreApi from '../../storeApi';
import {utils} from '../../../utils/utils';

class FullScreenShop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 0
    }

    // The cart icon may not be there.. so we need to ensure it's created in the fullscreen
    cartApi.createCartForm();
  }

  postShopRequest(type, data) {
    if (this.shopIntent) {
      this.shopIntent.postMessage(type, data);
    }
  }

  addToCartRequest() {
    if (this.shopIntent) {
      this.shopIntent.postMessage(providerEvents.addToCartRequest, {});
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const item = nextProps.item;
    if (item) {
      if (this.shopIntent) {
        if (this.props.item && this.props.item.id !== item.id) {
          this.shopIntent.postMessage(providerEvents.itemChanged, item.getDataForShop());
        }
      }
    }
  }

  messageReceived(type, payload, resolve, reject, providerId) {
    let {
      galleryId,
      imageUrl,
      isDemo
    } = this.props.additionalParams;
    isDemo = !!isDemo;
    switch (type) {
      case providerEvents.addToCart:
        const {
          uuid,
          quantity,
          metadata
        } = payload;
        cartApi.addToCart(uuid, imageUrl, galleryId, providerId, quantity, isDemo, metadata)
          .then(() => {
            resolve();
            cartApi.showCart()
          });
        break;
      case providerEvents.setHeight:
        this.setState(payload);
        break;
      case providerEvents.close:
        utils.isMobile() ? this.props.actions.toggleMobileShopFrame() : null
        break;
      case providerEvents.setMobileProductData:
        this.props.onSetMobileData(payload.type, payload.data);
        break;
      case providerEvents.setDefaultPrice:
        const priceData = payload;
        this.props.onSetMobileData(mobileViewTypes.singleProduct, priceData);
        break;
      case providerEvents.openModal:
        const { name, options } = payload;
        WixStoreApi.openProviderModal(name, options, { galleryId, imageUrl, isDemo }).then(resolve).catch(reject);
        break;
      default:
        break;
    }
  }

  render() {
    const { height } = this.state;
    const {connectedProviders} = this.props;

    const renderComponent = connectedProviders ? (
      <div className='full-screen-shop' style={{ height: height + 'px' }}>
        <ProviderIntent
          ref={r => this.shopIntent = r}
          intent={providerIntents.shop}
          tabIndex={utils.getTabIndex('fullscreenProvider')}
          onMessageReceived={(type, payload, resolve, reject, providerId) => {
            this.messageReceived(type, payload, resolve, reject, providerId);
          }}
          {...this.props}
          connectedProviders={connectedProviders}
        />
      </div>
    ) : null;
    return renderComponent;
  }
}

export default FullScreenShop;



// WEBPACK FOOTER //
// ./store/applications/gallery/fullscreenShop.js